module.exports = __webpack_public_path__ + "img/shg50_samurai02skin_shop.436fb3b3.png";